import { useQuery } from '@tanstack/react-query';
import type { PlatformStatusDto } from '@onesource/shared';
import { api } from '@/lib/api';

/** Server feature flags (shared cache with the Channels page). */
export function usePlatform() {
  return useQuery({ queryKey: ['platform'], queryFn: () => api.get<PlatformStatusDto>('/api/platform/status'), staleTime: 300_000 });
}

export function useSmartOperations(): boolean {
  return !!usePlatform().data?.features.smartOperations;
}
